module.exports = __webpack_public_path__ + "static/media/button.fa75ccd9.png";